// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2lrvs","selected":"Chip_selected__2FqEP"};